
export default function Button(props) {
  const {children, ...any} = props;

  return <button {...any}>{children}</button>;
}